import dayjs, { Dayjs } from "dayjs"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { DrawSummary } from "@/api/backofficeRest/generated/model"
import { Draw } from "./draw"
import { IDraw } from "./draw.types"

function parseDate(value: unknown, field: string): Dayjs {
  const parsed = dayjs(value as string)
  if (!parsed.isValid()) {
    throw new ParseError(new Error(`Invalid ${field}: ${String(value)}`))
  }
  return parsed
}

export const DrawParser: IParser<IDraw, DrawSummary> = {
  toDomain: (data: DrawSummary): IDraw => {
    try {
      return new Draw(
        String(data.id),
        data.name,
        data.displayName,
        parseDate(data.startDateTime, "startDateTime"),
        parseDate(data.entryDeadlineDateTime, "entryDeadlineDateTime"),
        parseDate(data.completionDateTime, "completionDateTime"),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
